import { render, staticRenderFns } from "./ReferralFeeWidget.vue?vue&type=template&id=02c13f2a&"
import script from "./ReferralFeeWidget.vue?vue&type=script&lang=js&"
export * from "./ReferralFeeWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReferralFeeWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports